export class CollapseboxAhpPageSuburbs {
    constructor() {
        this.COLLAPSED_CLASS = 'collapsebox__body--fixed_height';
    }

    init() {		
        const $wrap = jQuery('.js-collapsebox_ahp_page_suburbs');                 // collapse container
        if (!$wrap.length) return;

        const $body = $wrap.find('.js-collapsebox_ahp_page_suburbs_body');        // content body
        if (!$body.length) return;

        // Button is outside the wrapper, sibling within the same section
        const $section = $wrap.closest('section.arealist');
        const $btn = $section.find('.js-collapsebox_showmore_btn');               // external button
        const $label = $btn.find('.js-collapsebox_showmore_text');

        // True content height (unaffected by current clamp)
        const el = $body.get(0);
        const content_height = el ? el.scrollHeight : $body.outerHeight();
        
        if (el.scrollHeight > $body.outerHeight()) {
            // Collapse via CSS class and show button
            $body.addClass(this.COLLAPSED_CLASS).removeClass('js-active');
            $btn.show().attr('aria-expanded', 'false').removeClass('js-active');
            $label.text($btn.data('label_showmore') || 'Show more');
        } else {
            // Short content — no clamp, no button
            $body.removeClass(this.COLLAPSED_CLASS).removeClass('js-active');
            $btn.hide();
        }

        $btn.off('click.cb').on('click.cb', () => {
            const expanded = $btn.hasClass('js-active');

            if (expanded) {
                // collapse -> add clamp class
                $body.addClass(this.COLLAPSED_CLASS).removeClass('js-active');
                $btn.removeClass('js-active').attr('aria-expanded', 'false');
                $label.text($btn.data('label_showmore') || 'Show more');
            } else {
                // expand -> remove clamp class
                $body.removeClass(this.COLLAPSED_CLASS).addClass('js-active');
                $btn.addClass('js-active').attr('aria-expanded', 'true');
                $label.text($btn.data('label_showless') || 'Show fewer');
            }
        });
    }
}
